import { render } from "./ModalShipLpn.vue?vue&type=template&id=8ffa3304"
import script from "./ModalShipLpn.vue?vue&type=script&lang=js"
export * from "./ModalShipLpn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__